import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00a4b2a4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a4b2a4')) {
      api.createRecord('00a4b2a4', component.options)
    } else {
      api.reload('00a4b2a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00a4b2a4", function () {
      api.rerender('00a4b2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/return/inform/index.vue"
export default component.exports